export default "__VITE_ASSET__968382db__"